/**
 * Which service a clip's bytes live on, read off its id.
 *
 * The backend namespaces a ref by provider — `dbx:…` for Dropbox, unprefixed for Google
 * Drive — so the dashboard can label a clip without another round-trip. Kept to one function
 * so the prefix appears in exactly one place on this side too.
 */
const DROPBOX_PREFIX = 'dbx:';

// Null for Drive on purpose: a badge on every card in a Drive folder would say nothing, so
// only the clips that came from somewhere else get one.
export function sourceProviderLabel(fileId: string): string | null {
  return String(fileId || '').startsWith(DROPBOX_PREFIX) ? 'Dropbox' : null;
}
